import { AbstractControl, ValidatorFn } from '@angular/forms';

export function reqPackagingDateValidator(controlName: String, moveDate: Date, packDate: Date, delDate: Date): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        if (control.value !== null) {

            if (controlName == 'requestedPackingDate' && packDate && moveDate && packDate > moveDate) {
                return { dateCompare: true };
            } else if (controlName == 'requiredDeliveryDate' && delDate && moveDate && delDate < moveDate) {
                return { dateCompare: true };
            }
            if (controlName == 'moveDate' && (packDate && moveDate < packDate)) {
                return { dateCompare: true };
            } else if (controlName == 'moveDate' && (delDate && moveDate > delDate)) {
                return { dateCompare: true };
            }
        }
        return null;
    }
}

